<template>
    <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 cancel-title="Cancelar"
                 :ok-disabled=form.errors.any()
                 v-model="showModal"
                 @ok="handleOk">

       <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
           <label tag="div">Código</label>
           <b-form-input type="text"
                         placeholder="Código"
                         v-model="form.cd"
                         name="cd">
           </b-form-input>
           <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

           <label tag="div">Descrição</label>
           <b-form-input type="text"
                         placeholder="Descrição"
                         v-model="form.descr"
                         name="descr">
           </b-form-input>
           <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

           <label>Motivo</label>
           <multiselect v-model="motivoSelected"
           :options="optionsLivTpMotivo"
           track-by="value"
           label="label"
           :hide-selected="true"
           placeholder="Selecione"
           tag-placeholder="Selecionar"
           select-label="Selecionar"
           selected-label="Selecionado"
           deselect-label="Remover"
           ></multiselect>
           <b-form-feedback class="text-danger" v-text="form.errors.get('tp_motivo')" v-if="form.errors.has('tp_motivo')"></b-form-feedback>



           <label>Status</label>
           <b-form-group>
             <b-form-radio-group
               v-model="form.status"
               :options="optionsLivStatus"
               name="status"
               stacked
               plain
             ></b-form-radio-group>
           </b-form-group>
           <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

       </form>
              <div slot="modal-footer" class="w-100">
                     <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                     <div class="float-right">
                         <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                         <b-btn @click="showModal=false" variant="secondary">
                           Fechar
                         </b-btn>
                         <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                           Enviar
                         </b-btn>
                     </div>
              </div>
          </b-modal>

</template>
<script>
import AvisoErros from '../../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivTpMotivo: [],
      optionsLivStatus: [],
      motivoSelected: [],
      errors_array: [],
      form: new Form({ cd: '',
                       descr: '',
                       tp_motivo: '',
                       param_id: '',
                       status: []
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: 'tp_motivo.descr',
        title: 'Motivo',
        sortField: 'tp_motivo'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    motivoSelected(obj) {
        this.form.tp_motivo = obj.value;
    }
},
mounted() {
    this.getLivStatus();
    this.getLivTpMotivo();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.param_id);
        }
    },
    onCreate ()
    {
        console.log(this.tabela);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.grupoNcmSelected = [];
      this.motivoSelected = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.motivoSelected = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.motivoSelected = { label: data.tp_motivo.descr, value: data.tp_motivo.valor};
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivStatus()
    {
        this.helpForm.params = { tabela: this.tabela,
                                coluna: 'status' };

        this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    getLivTpMotivo() {
        this.helpForm.params = {
            tabela: 'param_motivo',
            coluna: 'tp_motivo'
        };

        this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj) => {
                    this.optionsLivTpMotivo.push({
                        label: obj.descr,
                        value: obj.valor
                    })
                })
            })
            .catch(errors => {
                new ReturnApi(errors, this, true, null, null, false);
                this.errors_array = '';
                this.errors_array = [];
                for (var property in errors) {
                  if (errors.hasOwnProperty(property)) {
                    if (typeof(errors[property]) === 'object') {
                      errors[property].forEach((obj) => {
                        this.errors_array.push({
                          erro: obj
                        });
                      });
                    }
                  }
                }
            });
    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
